import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { api } from '@/api';
import { DEFAULT_KEY_IMAGE_PARAMS } from '@/shared/constant';
import { useStudyGuard } from '@/shared/guard';
import { getMappedKeyImages } from '@/shared/util';
import { useKeyImagePollingStore } from '@/store';

export function useHiRadiologistKeyImages() {
  const { studyId } = useStudyGuard();

  const { hasStartedPolling, isRetrievingKeyImages } = useKeyImagePollingStore(
    useShallow((state) => ({
      hasStartedPolling: state.hasStartedPolling,
      isRetrievingKeyImages: state.isRetrievingKeyImages,
    })),
  );

  const { data, isFetching } = api.hi.radiologist.query.useGetKeyImages(
    { payload: { params: DEFAULT_KEY_IMAGE_PARAMS, studyId } },
    { enabled: false },
  );

  const value = useMemo(
    () => ({
      hasKeyImagesResponse: Boolean(data),
      isFetching,
      isProcessing: isRetrievingKeyImages || (hasStartedPolling && (data?.isProcessing ?? true)),
      keyImages: data?.response ? getMappedKeyImages(data.response) : [],
      loadedCount: data?.loadedCount ?? 0,
      totalCount: data?.totalCount ?? 0,
    }),
    [data, isFetching, hasStartedPolling, isRetrievingKeyImages],
  );

  return value;
}
